/** PAT for private GitHub content repos (documentation, quick-start, glossary). */
export function resolveGithubToken(): string {
  const token = process.env.GITHUB_TOKEN || process.env.GH_TOKEN || ''
  return token.trim()
}

export { formatGithubAuthorization } from '@common/lib/github/formatGithubAuthorization'

/** raw.githubusercontent.com ignores auth; retry via Contents API for private repos. */
export function shouldUseGithubContentsApi(responseStatus: number): boolean {
  return Boolean(resolveGithubToken()) && (responseStatus === 404 || responseStatus === 403)
}
